import React from "react";
import Center from "../../../../widget/common/ui/Center";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { SignupCompanyLogo } from "../widget/SignupWidgets";
import ImagePickerPreview from "../../../../widget/common/form/ImagePickerPreview";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { SignupAccountVerificationContextImport } from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";

const SignupPersonalLogoUploadContent = (props: { type: number }) => {
  const type: number = props.type;
  const logoSize = type === 1 ? 149 : type === 2 ? 180 : 200;

  const { updateFileString } = SignupAccountVerificationContextImport();

  const getPreview = (preview: string | null, fileDetail: File | null) => {
    updateFileString(preview, fileDetail);
  };

  return (
    <Div className="h-100 d-center">
      <Div>
        <Center>
          <SignupCompanyLogo title={AppTranslation.text("profile_photo")} />
        </Center>
        <Div className="text-center">
          <Center>
            <ImagePickerPreview getPreview={getPreview} size={logoSize}>
              <IconNormal name="upload-user" size={logoSize} />
            </ImagePickerPreview>
          </Center>
        </Div>
      </Div>
    </Div>
  );
};

export default SignupPersonalLogoUploadContent;
